export default "__VITE_ASSET__CjtiDbtB__"